import React from 'react'

import { withStepsState } from "./containers/containerStepsState"
import { withAppStepsState } from "./containers/containerAppStepsState"

import Icon from "./items/static/icon"

import styles from "./toPrevStepButton.module.scss"

const ToPrevStepButton = props => {
  const { onToPrevStep, onCloseApp, currentIndex } = props

  if (props.currentIndex === 0) return '';

  return (
    <button
      className={styles.toPrevStepButton}
      onClick={currentIndex === 0 ? onCloseApp : onToPrevStep}
    >
      <Icon name="back" />
    </button>
  )
}

export default withStepsState(withAppStepsState(ToPrevStepButton))